var lib_core = require("lib-core");
var ui_templates = require("ui-templates");

var EnvironmentTesterView = function(model) {
    var self = this;

    if(model.showBanner())
        this.getTemplate();
};

module.exports = EnvironmentTesterView;

EnvironmentTesterView.prototype.getTemplate = function(){
    var self = this;

    if(!this._template){
        this._template = new ui_templates.WarningBanner({
            target: $('.editor__warning__banner__holder'),
            fields: {
                'message': 'For an optimal experience, please consider using Chrome.'
            }
        });
    }
    return this._template;
};
